import { render } from "./BrowseTopicsChip.vue?vue&type=template&id=56e41723"
import script from "./BrowseTopicsChip.vue?vue&type=script&lang=js"
export * from "./BrowseTopicsChip.vue?vue&type=script&lang=js"
script.render = render

export default script